import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "mb-5 d-flex justify-end" }
const _hoisted_6 = { class: "btn-area" }

import { useRouter } from 'vue-router'
import PaginateWithCount from "@/components/PaginateWithCount.vue"
import getUserRolesResponseType from "@/types/responses/getUserRoles"
import getPaginateUserRolesResponseType from "@/types/responses/getPaginateUserRoles"
import getUserRolesRequestType from "@/types/requests/getUserRoles"
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import UserRoleList from "@/components/UserRoles/UserRoleList.vue"
import SearchForm from "@/components/UserRoles/SearchForm.vue"
import { useAuth } from "@/services/user/Auth0UserProvider"
import UserRoleService from "@/services/models/UserRole";
import SelectRoleChecker from '@/router/selectRoleChecker'
import { MANAGEMENT_OFFICE, SUB_MANAGEMENT_OFFICE } from "@/services/consts/user_role";
import { Ref, ref, onMounted, watch } from 'vue'
import Api from "@/services/api/ApiServiceFabrick"
import i18n from '@/lang/i18n'
import { saveDataToSessionStorage, loadDataFromSessionStorage, clearSessionStorage } from "@/services/functions/sessionStorage";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRoleList',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

document.title = i18n.global.t('pages.userRoles.title.listTitle')
const { loginWithRedirect } = useAuth()
const router = useRouter()

const userRoles: Ref<getUserRolesResponseType[]> = ref([])
const isLoading: Ref<boolean> = ref(false)
const isSearchCompleted: Ref<boolean> = ref(false)
const createAuthority: Ref<boolean> = ref(false)
const deleteAuthority: Ref<boolean> = ref(false)
const searchForm: Ref<getUserRolesRequestType> = ref({
  display_name: "",
  department: {},
  organization: {},
})
const totalPage: Ref<number> = ref(0)
const itemsPerPage: Ref<number> = ref(15)
const allElementsCount: Ref<number> = ref(0)
const currentPage: Ref<number> = ref(1)
const errors = ref({
  organization: [],
  department: [],
  display_name: []
} as {organization: string[], department: string[], display_name: string[]})

const props = __props

onMounted(() => {
  getAuthorities()
  firstSearchList()
})

watch(currentPage, () => {
  const param = makeParam(searchForm.value)
  getUserRoles(param)
})

async function getAuthorities() {
  const authorityList = await AuthorityCacheApi.getWithParse()
  createAuthority.value = !!authorityList["octlink.user_role.create"]
  deleteAuthority.value = !!authorityList["octlink.user_role.delete"]
}

function moveToUserRoleForm() {
  router.push('/user-roles/form/')
}

function firstSearchList(){
  const current_role = SelectRoleChecker.getCurrentRole()
  let organization_type = ""
  if (current_role?.organization_type) {
    organization_type = current_role.organization_type
  }
  const savedSearchParam = loadDataFromSessionStorage('userRoleSearchParam');
  if (savedSearchParam) {
    getUserRoles(savedSearchParam as getUserRolesRequestType)
  } else if (organization_type == SUB_MANAGEMENT_OFFICE.type) {
    const param = makeParam(searchForm.value)
    getUserRoles(param)
  }
}

function searchList (form: getUserRolesRequestType) {
  searchForm.value = form
  currentPage.value = 1
  const param = makeParam(form)
  getUserRoles(param)
  saveDataToSessionStorage('userRoleSearchParam', param)
}

function makeParam(form: getUserRolesRequestType){
  let param = {} as getUserRolesRequestType
  param.display_name = form.display_name
  if (form.department && form.department.id) {
    param.department_id = form.department.id
    param.department_name = form.department.name
  }
  if (form.organization) {
    param.office_id = form.organization.id
    param.office_type = UserRoleService.converetOfficeType(form.organization.type)
  }
  param.page=currentPage.value
  return param
}

function getUserRoles(searchParams: getUserRolesRequestType) {
  isLoading.value = true
  isSearchCompleted.value = true
  Api().getUserRoles(searchParams).then((data: getPaginateUserRolesResponseType) => {
    currentPage.value = data.current_page
    totalPage.value = data.last_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
    userRoles.value = data.data
    isLoading.value = false
  }).catch((error: any) => {
    isLoading.value = false
    isSearchCompleted.value = false
    return errorHandle(error.response)
  })
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      break
    case 422:
      errors.value = formatErrorMessages(res.data.errors)
  }
}

function formatErrorMessages(errors){
  let errorMessages = {
    organization: [] as string[],
    department: [] as string[],
    display_name: [] as string[]
  }
  if (errors.office_id) {
    errorMessages.organization = errors.office_id
  }
  if (errors.department_id) {
    errorMessages.department = errors.department_id
  }
  if (errors.display_name) {
    errorMessages.display_name = errors.display_name
  }
  return errorMessages
}

function setSearchErrors(errorMessages: {organization: string[], department: string[], display_name: string[]}){
  errors.value = errorMessages;
}

function deleteUserRole(id: number){
  let newUserRoles = [] as getUserRolesResponseType[]
  userRoles.value.forEach( (role) => {
    if (role.id != id) {
      newUserRoles.push(role)
    }
  })
  userRoles.value = newUserRoles
}

function clearUserRoleSearchParam() {
  clearSessionStorage('userRoleSearchParam')
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.userRoles.title.listTitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (createAuthority.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "exec-btn mt-0",
                onClick: moveToUserRoleForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.newCreate')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(UserRoleList, {
          class: "mb-2",
          userRoles: userRoles.value,
          isLoading: isLoading.value,
          isSearchCompleted: isSearchCompleted.value,
          deleteAuthority: deleteAuthority.value,
          showFlash: __props.showFlash,
          onDeleteUserRole: deleteUserRole
        }, null, 8, ["userRoles", "isLoading", "isSearchCompleted", "deleteAuthority", "showFlash"]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          itemsPerPage: itemsPerPage.value,
          allElementsCount: allElementsCount.value,
          showItemCount: true
        }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"])
      ])
    ]),
    _createVNode(SearchForm, {
      isLoading: isLoading.value,
      errors: errors.value,
      onSearch: searchList,
      onSetErrors: setSearchErrors,
      onClear: clearUserRoleSearchParam
    }, null, 8, ["isLoading", "errors"])
  ]))
}
}

})